import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import { init } from './dataEspecialActions';
import LabelAndInput from '../common/form/labelAndInput';
import Button from '../common/form/button';
import Checkbox from '../common/form/checkbox';

import SelectPlano from '../common/selectdb/selectPlano';
import SelectMes from './selectMes';
import SelectDia from './selectDia';
import html2canvas from 'html2canvas';
import { toastr } from 'react-redux-toastr';
import axiosInstance from '../main/axios';

class DataEspecialForm extends Component {
  constructor(props) {
    super(props);

    this.componentRef = React.createRef();

    this.salvarDataEspecial = this.salvarDataEspecial.bind(this);
    this.applyDateRulesIfNeeded = this.applyDateRulesIfNeeded.bind(this);
    this.handleChangePlano = this.handleChangePlano.bind(this);
  }

  async salvarDataEspecial() {
    // Pré-validação do plano selecionado para o controlador atual
    try {
      const contId = this.props.controlador_id;
      const planoId = this.props.plano_id;
      if (contId && parseInt(contId) !== 0 && planoId && planoId !== '0' && planoId !== '63' && planoId !== '32') {
        await axiosInstance.get(`/trocaplanos/validar-plano/${contId}/${planoId}`);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const message = error.response.data.message;
        toastr.error('Plano Inválido', message);
        return; // Bloqueia o salvamento
      } else {
        toastr.error('Erro', 'Erro ao validar plano. Tente novamente.');
        return;
      }
    }

    await html2canvas(this.componentRef.current).then(canvas => {
      canvas.style.display = 'none';
      let image = canvas.toDataURL('png');
      this.props.change('imageLog', image);
    });

    this.props.handleSubmit();
  }

  async handleChangePlano(event) {
    const planoId = event && event.target ? event.target.value : undefined;
    const contId = this.props.controlador_id;

    // Não valida quando: sem controlador específico, plano não escolhido, ou intermitente
    if (!planoId || planoId === '0' || planoId === '63' || !contId || parseInt(contId) === 0) {
      return;
    }

    try {
      await axiosInstance.get(`/trocaplanos/validar-plano/${contId}/${planoId}`);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const message = error.response.data.message;
        toastr.error('Plano Inválido', message);
        // Limpa o campo de plano
        this.props.change('plano_id', '0');
      } else {
        toastr.error('Erro', 'Erro ao validar plano. Tente novamente.');
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data_mes !== this.props.data_mes || prevProps.data_dia !== this.props.data_dia) {
      this.applyDateRulesIfNeeded();
    }
  }

  applyDateRulesIfNeeded() {
    const mes = +this.props.data_mes;
    const dia = +this.props.data_dia;
    if (!mes || !dia) return;

    const now = new Date();
    const todayMonth = now.getMonth() + 1; // 1-12
    const todayDay = now.getDate(); // 1-31

    // Se for exatamente hoje: avança para o próximo dia (com rollover de mês/ano)
    if (mes === todayMonth && dia === todayDay) {
      // calcula dias no mês atual
      const daysInMonth = new Date(now.getFullYear(), mes, 0).getDate();
      let novoDia = dia + 1;
      let novoMes = mes;
      if (novoDia > daysInMonth) {
        novoDia = 1;
        novoMes = mes === 12 ? 1 : mes + 1;
      }
      this.props.change('mes', novoMes);
      this.props.change('dia', novoDia);
      toastr.warning(
        'Atenção',
        'Não é permitido adicionar uma data especial com a mesma data do dia atual, escolha outro dia.',
        { position: 'top-right' },
      );
      return;
    }

    // Se a data escolhida (mes/dia) for anterior à data atual, interpretamos como próximo ano.
    // Não há campo de ano no formulário/BD, então nenhuma alteração é necessária aqui.
  }

  render() {
    const { handleSubmit, controlador_id, data_mes } = this.props;
    const requiredSelect = value => (value === '0' || value === undefined ? 'Obrigatório' : undefined);
    const requiredTime = value => (value === undefined || value === '' ? 'Obrigatório' : undefined);

    return (
      <form onSubmit={handleSubmit} ref={this.componentRef} className="plano-forcado-form-premium">
        <div className="plano-forcado-container" style={{ gridTemplateColumns: '1fr' }}>
          <div className="plano-forcado-section">
            <div className="plano-forcado-card">
              <div className="card-body-custom">
                <div className="form-row-premium">
                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-hashtag" /> Código
                    </label>
                    <Field
                      name="sequencia"
                      component={LabelAndInput}
                      cols="12"
                      hideLabel={true}
                      placeholder="Automático"
                      readOnly={true}
                    />
                  </div>

                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-list-alt" /> Plano
                    </label>
                    <SelectPlano
                      cols="12"
                      hideLabel={true}
                      data-controlador-id={controlador_id}
                      data-plano-piscante={true}
                      onChange={this.handleChangePlano}
                      validate={requiredSelect}
                    />
                  </div>
                </div>

                <div className="form-row-premium">
                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-calendar-o" /> Mês
                    </label>
                    <SelectMes cols="12" hideLabel={true} validate={requiredSelect} />
                  </div>

                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-calendar-check-o" /> Dia
                    </label>
                    <SelectDia cols="12" hideLabel={true} data-mes={data_mes || 12} validate={requiredSelect} />
                  </div>
                </div>

                <div className="form-row-premium">
                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-clock-o" /> Horário Inicial
                    </label>
                    <Field
                      name="horario_inicial"
                      component={LabelAndInput}
                      type="time"
                      cols="12"
                      hideLabel={true}
                      validate={requiredTime}
                    />
                  </div>

                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-clock-o" /> Horário Final
                    </label>
                    <Field
                      name="horario_final"
                      component={LabelAndInput}
                      type="time"
                      cols="12"
                      hideLabel={true}
                      validate={requiredTime}
                    />
                  </div>
                </div>

                <div className="form-group-premium">
                  <label className="label-premium">
                    <i className="fa fa-circle-o-notch" /> Anéis
                  </label>
                  <div className="aneis-checkbox-group">
                    <Field cols="" name="anel1" component={Checkbox} label="Anel 1" type="checkbox" />
                    <Field cols="" name="anel2" component={Checkbox} label="Anel 2" type="checkbox" />
                    <Field cols="" name="anel3" component={Checkbox} label="Anel 3" type="checkbox" />
                    <Field cols="" name="anel4" component={Checkbox} label="Anel 4" type="checkbox" />
                  </div>
                </div>

                <div
                  className="button-group-premium"
                  style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '24px' }}
                >
                  <Button
                    type="button"
                    className="primary"
                    icon="check"
                    label="Salvar"
                    onClick={this.salvarDataEspecial}
                  />
                  <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

// destroyOnUnmount: false permite utilizar o mesmo componente form para cadastrar e para alterar, se tirar essa propriedade o sistema cria um
// form limpo para o update
DataEspecialForm = reduxForm({ form: 'dataEspecialForm', destroyOnUnmount: false })(DataEspecialForm);

const selector = formValueSelector('dataEspecialForm');
const mapStateToProps = state => ({
  controlador_id: selector(state, 'controlador_id') || 0,
  data_mes: selector(state, 'mes') || 0,
  data_dia: selector(state, 'dia') || 0,
});

const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataEspecialForm);
